import React from 'react'
import { Form } from 'react-bootstrap'
import { FormData } from './RegisterForm'

interface Step1Props {
  formData: FormData
  updateFormData: (field: keyof FormData, value: string | boolean) => void
  errors: {
    agentCode: string
    name: string
    email: string
    consent: string
  }
  onSubmit: (e: React.FormEvent) => void
}

export default function Step1({ formData, updateFormData, errors, onSubmit }: Step1Props) {
  const handleAgentCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateFormData('agentCode', e.target.value)
  }

  return (
    <>
      <h1>RSVP NOW to the Principal 2026 Q2 Agency Rolldown Virtual Event</h1>
      <p className="muted">Proceed to RSVP by entering your Agent Code</p>
      <Form className="form" onSubmit={onSubmit}>
        <Form.Group>
          <Form.Label>Enter your Agent Code</Form.Label>
          <Form.Control
            className={`form-input min-w-400px ${errors.agentCode ? 'is-invalid' : ''}`}
            type="text"
            placeholder="example: 12345"
            value={formData.agentCode}
            onChange={handleAgentCodeChange}
          />
          {errors.agentCode && <div className="invalid-feedback d-block">{errors.agentCode}</div>}
        </Form.Group>
      </Form>
      <div className="hint">
        <p>
          Enter your Agent Code without the leading "0". Example: If your code is 00012345, enter 12345.
          <br />
          Only valid match will be accepted.
          <br />
          Replacements or representatives are not allowed.
        </p>
        <p>
          <b>DO NOT register on behalf of other participants.</b>
          <br />A minimum fee will be charged if an agent is found to have abused the registration process.
        </p>
      </div>
    </>
  )
}
